// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1716903902544
      var cssReload = require("/home/gitlab-runner/builds/MkSfms4e/0/caredb/caredb-react-js/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  